import { useState } from 'react';
import { faqData } from '@/mocks/faq';

export default function FaqSection() {
  const [openIndex, setOpenIndex] = useState<number | null>(null);

  const toggleFaq = (idx: number) => {
    setOpenIndex(openIndex === idx ? null : idx);
  };

  const faqSchema = {
    '@context': 'https://schema.org',
    '@type': 'FAQPage',
    mainEntity: faqData.map((item) => ({
      '@type': 'Question',
      name: item.question,
      acceptedAnswer: {
        '@type': 'Answer',
        text: item.answer,
      },
    })),
  };

  return (
    <section className="bg-background-100 py-16 md:py-24">
      <div className="w-full px-4 md:px-8">
        <div className="max-w-3xl mx-auto">
          <div className="text-center mb-12 md:mb-16">
            <p className="text-xs font-semibold uppercase tracking-widest text-foreground-400 mb-3">Got Questions?</p>
            <h2 className="text-3xl md:text-5xl font-heading font-bold text-foreground-950">
              Frequently Asked Questions About Pandabuy Spreadsheet
            </h2>
          </div>

          <script type="application/ld+json">{JSON.stringify(faqSchema)}</script>

          <div className="flex flex-col gap-3">
            {faqData.map((faq, idx) => (
              <div key={idx} className="bg-background-50 rounded-lg overflow-hidden">
                <button
                  className="w-full flex items-center justify-between p-5 text-left cursor-pointer"
                  onClick={() => toggleFaq(idx)}
                >
                  <span className="text-sm md:text-base font-medium text-foreground-900 pr-4">
                    {faq.question}
                  </span>
                  <span className={`w-5 h-5 flex items-center justify-center flex-shrink-0 transition-transform duration-200 ${openIndex === idx ? 'rotate-45' : ''}`}>
                    <i className="ri-add-line text-foreground-400"></i>
                  </span>
                </button>
                {openIndex === idx && (
                  <div className="px-5 pb-5">
                    <p className="text-sm text-foreground-600 leading-relaxed">{faq.answer}</p>
                  </div>
                )}
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}